import { render, staticRenderFns } from "./OfflineDocs.vue?vue&type=template&id=79a524c9&scoped=true&"
import script from "./OfflineDocs.vue?vue&type=script&lang=js&"
export * from "./OfflineDocs.vue?vue&type=script&lang=js&"
import style0 from "./OfflineDocs.vue?vue&type=style&index=0&id=79a524c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a524c9",
  null
  
)

export default component.exports